<template>
  <div>
      <h3 class="page__title">网点服务日报【建设中】</h3>
        
        <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">截止日期</label>
          </div>
          <div class="weui-cell__bd" @click="pickerDate" >
            <a style="align-text:left ;color: #238E23;">{{dateStr}}</a>
          </div>
      </div>
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">网点</label>
          </div>
          <div class="weui-cell__bd" @click="pickPos">
              <a  style="align-text:left;color: #238E23;">{{posSelected.label}}</a>
          </div>
          
      </div>
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">追溯天数</label>
          </div>
          <div class="weui-cell__bd" @click="pickMasterDay">
              <a  style="align-text:left;color: #238E23;">{{this.MasterDay}}</a>
          </div>
          
      </div>
      
      <hr/>
    <!--
    <ChartLine ref="chart_line_one" style="height:400px"/> -->
    <div class="table-responsive" v-if="reportData30.length > 0">
      <table class="table table-striped " style="font-size: small;" >
        <thead>
          <tr>
            <th scope="col">日期范围</th>
            <th scope="col">总流入</th>
            <th scope="col">流出</th>
            <th scope="col">净流入</th>

          </tr>
        </thead>
        <tbody>
          <tr >
            <th scope="row">{{ this.dateStr}}至<br>{{this.DeadlineDay}}</th>
            <td>￥{{this.AllinAmount}}<br/>共{{this.AllinCount}}笔</td>
            <td>￥{{this.AlloutAmount}}<br/>共{{this.AlloutCount}}笔</td>
            <td>￥{{this. AllrealAmount}}</td>
          </tr>
          
        </tbody>
      </table>    
    </div>
    

      
    <div class="table-responsive panel-footer" style="height: 260px;overflow: auto;" v-if="reportData.length > 0">
      <table class="table table-striped " style="font-size: small;" >
        <thead>
          <tr>
            <th scope="col">日期</th>
            <th scope="col">流入</th>
            <th scope="col">流出</th>
            <th scope="col">净流入</th>

          </tr>
        </thead>
       
        <tbody>
          <tr v-for="itm in reportData" :key="itm.date">
            <th scope="row">{{itm.get("date")}}</th>
            <td>￥{{itm.get("inAmount").toFixed(2)}}<br/>共{{itm.get("inCount")}}笔</td>
            <td>￥{{itm.get("outAmount").toFixed(2)}}<br/>共{{itm.get("outCount")}}笔</td>
            <td>￥{{itm.get("realAmount").toFixed(2)}}</td>
          </tr>
          
        </tbody>
      </table>    
    </div>
    <div id="loadingToast" style="display: none;" v-else-if="ing">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <span class="weui-primary-loading weui-primary-loading_transparent weui-icon_toast">
              <span class="weui-primary-loading__dot"></span>
            </span>
            <p class="weui-toast__content">加载中</p>
        </div>
    </div>
    <div class="weui-msg" v-else>
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">没有订单</h2>
            <p class="weui-msg__desc">指定查询条件未检索到订单，请修改查询条件。</p>
        </div>
    </div>
  
    <div role="alert" class="weui-toptips weui-toptips_warn" id="warnToast">获取数据失败</div>
    
    
    <boxGraph ref="chart_line_box" style="height:300px;width:100%"  />
  </div>


  
</template>
<style>


</style>
  
<script>
import ChartLine from '../components/chartLine.vue'
import boxGraph from '../components/boxGraph.vue'

import 'bootstrap/dist/css/bootstrap.css'

import axios from 'axios'
import { forEach } from 'emojis-list'
import JQ from 'jquery'

function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }

export default {


  data () {
    return {
      ing:true,
      partnerid:"",
      posSelected:{label: '所有',
            value: 0},
      date:new Date(),
      posList: [{
            label: '所有',
            value: 0
        }],
      dateStr : new Date().Format("yyyy-MM-dd") ,
      reportData : [],
      reportData30 : [],
      TotalreportData30: [],
      AllinCount:'',
      AllinAmount:'',
      AlloutCount:'',
      AlloutAmount:'',
      AllrealAmount:'',
      MasterDay:'31',
      Daylist:[],
      DeadlineDay:''
      
    }
  },
  mounted() {
    console.log('creat')
    
    const {name,xData,yData} = this
       console.log(this.$refs)
       // this.$refs.chart_line_one.initChart(name,xData,yData)

       console.log( this.partnerid,sessionStorage.getItem("partnerid"))
       this.partnerid = sessionStorage.getItem("partnerid")
       console.log( this.partnerid,sessionStorage.getItem("partnerid"))
       this.creatDaylist()

       this.initPosList(this.partnerid)

       this.getReport();
       this.getReport30();
       
  },
    components: {
       ChartLine,
       boxGraph,
    },
  methods: {    
    creatDaylist(){
      
      for(let num =2;num<32;num++)
      {  this.Daylist.push(num)
      }
      
      console.log(this.Daylist)
    },
    pickerDate() {
      let that = this;
      this.$weui.datePicker({
            start: 1990,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
                that.dateStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.date = new Date(result[0].value,result[1].value,result[2].value)
            },
            onConfirm: function (result) {
                console.log(result);
                that.getReport(that.dateStr);
                that.getReport30(that.dateStr);
            },
            title: '请选择日期'
        });
    },
    initPosList(pid){
       let pelist = JSON.parse(sessionStorage.getItem("posListOf_"+pid));

       console.log(pelist,pid)
       
       pelist.forEach(item => {
        let tmp={};
        tmp.label = item.name;
        tmp.value = item.posId;

        this.posList.push(tmp);
       });

       /*
       this.posList.push({
            label: '所有',
            value: 0
        });*/
       
    },
    pickPos() {
      let that = this;
      this.$weui.picker(this.posList, {
            onChange: function (result) {
                console.log(result);
                that.posSelected = result[0]
            },
            onConfirm: function (result) {
                console.log(result);
                that.getReport(that.dateStr);
                
            },
            title: '选择网点'
        });
    },
    pickMasterDay() {
      let that = this;
      this.$weui.picker(this.Daylist, {
            onChange: function (result) {
                console.log(result);
               
            },
            onConfirm: function (result) {
                console.log(result);
                
                that.MasterDay = result[0]
                that.MasterDay = that.MasterDay.value
                console.log( that.MasterDay)
                console.log( 222222222222222222222222222222222222222222222)
                that.getReport30();
                that.getReport();
                
                
            },
            title: '选择网点'
        });
    },
    fillDays7() {
      let mapReport = new Map();
      mapReport.clear();
      let val_org = {
        "date":"",
        "inCount":0,
        "inAmount":0.0,
        "outCount":0,
        "outAmount":0.0,
        "realAmount":0.0,
      };
      let lDay = this.$moment(this.dateStr,'YYYY-MM-DD');

      // console.log(lDay)

      let cnt = this.MasterDay;
      while (cnt >= 1) {
        let val = new Map();

        for (var key in val_org) {
          val.set(key,val_org[key]);
        }
        val.set('date',lDay.format('YYYY-MM-DD'));
        console.log(val);

        mapReport.set(lDay.format('YYYY-MM-DD'),val);
        cnt--;

        lDay = lDay.subtract(1,'days')
        
        // console.log(cnt,lDay,lDay.format('YYYY-MM-DD'))

        
      }

      console.log(mapReport)

      return mapReport;

    },
    fillDays30() {
      let mapReport = new Map();
      mapReport.clear();
      let val_org = {
        "date":"",
        "inCount":0,
        "inAmount":0.0,
        "outCount":0,
        "outAmount":0.0,
        "realAmount":0.0,
      };
      let lDay = this.$moment(this.dateStr,'YYYY-MM-DD');

      // console.log(lDay)

      let cnt = this.MasterDay;
      while (cnt >= 1) {
        let val = new Map();

        for (var key in val_org) {
          val.set(key,val_org[key]);
        }
        val.set('date',lDay.format('YYYY-MM-DD'));
        console.log(val);

        mapReport.set(lDay.format('YYYY-MM-DD'),val);
        cnt--;

        lDay = lDay.subtract(1,'days')
        
        // console.log(cnt,lDay,lDay.format('YYYY-MM-DD'))

        
      }

      console.log(mapReport)

      return mapReport;

    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 2000);
    },
    getReport(dstr){

      
      console.log("getReport----------------------------------------------------------------------------------------")

      let paras = {};

      paras.pid = this.partnerid;
      paras.date = this.dateStr + " 23:59:59";
      paras.daynum = this.MasterDay;

      if(this.posSelected.value != 0)  paras.posid=this.posSelected.value;
      
      let that = this;
      this.ing=true;
      axios.get('/zmomc/cashFlowDailyReport', {
        params: paras
      }).then(res  =>  {
        console.log(res.data)  
        if((res.data == null)) {
          that.showError();return;
        }

        if(res.data.length ==0){
          // alert("选定的日期没有数据"); 
          that.reportData = [];
          that.$refs.chart_line_box.initChart([],[],[],[])
          return;
        }
        let mapReport = this.fillDays7();
        res.data.forEach(item => {
          // console.log("AAAAAAAAAA",mapReport)

          if(item.ostate > 1 ) {              
              let val = mapReport.get(item.odate);
              
              console.log("item",item,"val",val);
                            
              if((item.ostate == 3) || (item.ostate == 2) ){
                val.set("inCount",val.get("inCount") + parseFloat(item.ocount))
                val.set("inAmount",val.get("inAmount") + parseFloat(item.oamount))
                val.set("realAmount",val.get("realAmount") + parseFloat(item.oamount))
              }
              else if( (item.ostate == 4)){
                val.set("inCount",val.get("inCount") + parseFloat(item.ocount))
                val.set("inAmount",val.get("inAmount") + parseFloat(item.oamount))
                val.set("outCount",val.get("outCount") + parseFloat(item.ocount))
                val.set("outAmount",val.get("outAmount") + parseFloat(item.oamount))

              }
              
              console.log("val",val);
            }
          })
          
          console.log(mapReport)
          
          let arrayObj=Array.from(mapReport);
          console.log(arrayObj)
          arrayObj.sort(function(a,b){return b[0].localeCompare(a[0])})

          console.log(arrayObj)
          let arrTemp= [];
          let xData =[];
          let yDataIn =[];
          let yDataOut =[];
          let yDataReal =[];
          arrayObj.forEach(item => {
            // console.log(item)
            arrTemp.push(item[1]);

            xData.push(item[0]);
            // .toFixed(2)
            yDataIn.push(parseFloat( item[1].get("inAmount").toFixed(2)));
            yDataOut.push(parseFloat(item[1].get("outAmount").toFixed(2)));
            yDataReal.push(parseFloat(item[1].get("realAmount").toFixed(2)));
          })
          that.reportData = arrTemp
          console.log(that.reportData)

          
          console.log(xData,yDataIn,yDataOut,yDataReal)
         that.$refs.chart_line_box.initChart(xData,yDataIn,yDataOut,yDataReal)

         that.ing=false;

      })
        
    },
    getReport30(dstr){

      
console.log("getReport30---------------------------------------------------------------------------------------")

let paras = {};

paras.pid = this.partnerid;
paras.date = this.dateStr + " 23:59:59";
paras.daynum = this.MasterDay;

if(this.posSelected.value != 0)  paras.posid=this.posSelected.value;

let that = this;
this.ing=true;
axios.get('/zmomc/cashFlowDailyReport', {
  params: paras
}).then(res  =>  {
  console.log(res.data)  
  if((res.data == null)) {
    that.showError();return;
  }

  if(res.data.length ==0){
    // alert("选定的日期没有数据"); 
    that.reportData = [];
    that.$refs.chart_line_box.initChart([],[],[],[])
    return;
  }
  let mapReport = this.fillDays30();
  res.data.forEach(item => {
    // console.log("AAAAAAAAAA",mapReport)

    if(item.ostate > 1 ) {              
        let val = mapReport.get(item.odate);
        
        console.log("item",item,"val",val);
                      
        if((item.ostate == 3) || (item.ostate == 2) ){
          val.set("inCount",val.get("inCount") + parseFloat(item.ocount))
          val.set("inAmount",val.get("inAmount") + parseFloat(item.oamount))
          val.set("realAmount",val.get("realAmount") + parseFloat(item.oamount))
        }
        else if( (item.ostate == 4)){
          val.set("inCount",val.get("inCount") + parseFloat(item.ocount))
          val.set("inAmount",val.get("inAmount") + parseFloat(item.oamount))
          val.set("outCount",val.get("outCount") + parseFloat(item.ocount))
          val.set("outAmount",val.get("outAmount") + parseFloat(item.oamount))

        }
        
        console.log("val",val);
      }
    })
    
    console.log(mapReport)
    
    let arrayObj=Array.from(mapReport);
    console.log(arrayObj)
    arrayObj.sort(function(a,b){return b[0].localeCompare(a[0])})

    console.log(arrayObj)
    let arrTemp= [];
   
    arrayObj.forEach(item => {
      // console.log(item)
      arrTemp.push(item[1]);

      
    })
    that.reportData30 = arrTemp
    // inAmount' => 382.99, 'outCount' => 0, 'outAmount'
    console.log(that.reportData30)
    console.log('1111111111111111111111111111111111111111111111111')
    let num =0  
    let num1=0.0
    let num2=0
    let num3=0.0
    let num4=0.0
    let num5=''
    that.reportData30.forEach(item => {
       num+=parseFloat(item._c.get('inCount'))
       num1+=parseFloat(item._c.get('inAmount'))
       num2+=parseFloat(item._c.get('outCount'))
       num3+=parseFloat(item._c.get('outAmount'))
       num4+=parseFloat(item._c.get('realAmount'))
      // this.AllinCount+=item._c.get('inCount')
      num5=item._c.get('date')
     
    })
    console.log(num)
    console.log(num1)
    console.log(num2)
    console.log(num3)
    console.log(num4)
    console.log(num5)
    this.AllinCount=num.toFixed(2)
    this.AllinAmount=num1.toFixed(2)
    this.AlloutCount=num2.toFixed(2)
    this.AlloutAmount=num3.toFixed(2)
    this.AllrealAmount=num4.toFixed(2)
    console.log(this.AllinCount)
    console.log(this.AllinAmount)
    console.log(this.AlloutCount)
    console.log(this.AlloutAmount)
    console.log(this.AllrealAmount)
    this.DeadlineDay=num5
    console.log( this.DeadlineDay)
    

    
    
   

    
   that.ing=false;

})
  
}
  }
}

</script>


// WEBPACK FOOTER //
// src/views/report_service.vue